import { useKeycloak } from "@react-keycloak/web";
import { Fragment, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Role } from "../types";
import Loader from "./ui/Loader";

interface PrivateRouteProps {
  children: ReactNode;
  roles: Role[];
}

export default function PrivateRoute({ children, roles }: PrivateRouteProps) {
  const { keycloak, initialized } = useKeycloak();
  // const { role } = useAppSelector((state) => state.auth);

  // console.log(keycloak?.token);

  // console.log(keycloak);
  // console.log("initialized", initialized);

  // const isAccess = roles?.find((item) => item === role);
  const isAccess = true;

  if (!initialized) {
    return <Loader />;
  }

  if (keycloak?.token && isAccess) {
    return <Fragment>{children}</Fragment>;
  }

  return <Navigate to="/" />;
}
